import { IUserProfile } from "../@types/Wyanoke/UserProfile";
const globalsPromise = new Promise<void>((resolve, reject) => {
  let complete = false;

  const testForSuccess = () => {
    if (complete) {
      return;
    }

    complete = true;

    if (window.UserProfile) {
      console.log("Globals loaded.");
    } else {
      console.warn("Globals not loaded.");
    }

    resolve();
  };

  const legacyJQuery = window.$j;
  if (!legacyJQuery) {
    console.warn("Could not find legacy jQuery.");
    testForSuccess();

    return;
  }

  // LATENCY: check one last time for window.UserProfile before waiting
  if (window.UserProfile) {
    testForSuccess();
  } else {
    window.setTimeout(
      () => {
        if (!complete) {
          console.warn("Timeout waiting for global load event.");
          testForSuccess();
        }
      },
      // Justification: 10000 = 10 second timeout waiting for globals to load.
      // LATENCY: timeout has been reduced to 5 seconds
      // tslint:disable-next-line:no-magic-numbers
      5000
    );

    legacyJQuery(window).one("globalsloaded", testForSuccess);
  }
});

const defaultGuid = "00000000-0000-0000-0000-000000000000";

export const WyanokeUtil = {
  async loadUserProfile(
    loggedIn: boolean,
    complete: boolean
  ): Promise<IUserProfile | null> {
    // The UserProfile global object is loaded asynchronously.  It may already
    // be on the page, and it may not.
    const existing = window.UserProfile;
    if (existing) {
      if (loggedIn && complete) {
        if (
          existing.complete &&
          existing.contactid &&
          existing.contactid !== defaultGuid
        ) {
          return existing;
        }
      } else if (loggedIn) {
        if (existing.contactid && existing.contactid !== defaultGuid) {
          return existing;
        }
      } else {
        return existing;
      }
    }

    await globalsPromise;
    const profile = window.UserProfile;

    if (loggedIn) {
      if (!profile || !profile.contactid) {
        console.warn("No global user context.");

        return null;
      }

      if (profile.contactid === defaultGuid) {
        console.log("User is not known to Sitecore.");

        return null;
      }
    }

    return profile || null;
  },
  GetDateISO8601() : string {
    const date = new Date();
    const tzo = date.getTimezoneOffset();

    // the timezoneoffset returns what needs to be ADDED to the time, so the signs are flipped. GMT-5:00 (eastern) returns "300"
    const dif = tzo >= 0 ? "-" : "+";
    const pad = function (num : number) : string {
        const norm = Math.floor(Math.abs(num));

        // tslint:disable-next-line: no-magic-numbers
        return (norm < 10 ? "0" : "") + norm;
    };
    return date.getFullYear() +
        "-" + pad(date.getMonth() + 1) +
        "-" + pad(date.getDate()) +
        "T" + pad(date.getHours()) +
        ":" + pad(date.getMinutes()) +
        ":" + pad(date.getSeconds()) +
        dif + pad(tzo / 60) +
        ":" + pad(tzo % 60);
  },
  async loadContext(required: boolean): Promise<IContext | null> {
    // The window.Context global object is loaded asynchronously.
    // It may already be on the page, and it may not.
    const existing = window.Context;
    if (existing) {
      if (required) {
        if (existing.itemid) {
          return existing;
        }
      } else {
        return existing;
      }
    }

    await globalsPromise;
    const context = window.Context;

    if (required) {
      if (!context) {
        console.warn("No global window.Context.");

        return null;
      }
    }

    return context || null;
  },
  isMobile() :boolean {
    const lower = navigator.userAgent.toLowerCase();

    // tslint:disable-next-line:max-line-length
    return !lower.includes("xoom") &&
           !lower.includes("sch-i800") &&
           (
             lower.includes("mobile") &&
             !lower.includes("ipad") ||
             lower.includes("android") &&
             lower.includes("mobile") ||
             (
               lower.includes("phone") ||
               lower.includes("blackberry") ||
               (
                lower.includes("windows ce") ||
                lower.includes("opera mini")
               )
              ) ||
              lower.includes("nokia") ||
              lower.includes("palm")
            );
  },
  logOut() : boolean {
    let loggedOut = false;
      $.post("/~/user/logout", () => {
        console.log("logged out and reloading");
         window.location.href =
         window.location.href.replace(window.location.search,"");
         if (window.location.href.indexOf("#") > -1) {
           window.location.reload();
         }

         loggedOut = true;
      }).fail((): void => {
        console.log("failed to logout user");
      });

      return loggedOut;
  },
  logIn() : void {
    // TODO: get this URL from a global var or something set in sc
    $.get('/utilityapp/json/na/li/healiotwo/{ACC50322-FB7D-42FC-940E-84BDDAD3B84D}',function (data){$('body').append(data);})
  }
};
